import { Spinner } from '@ui';
import { cx } from 'class-variance-authority';
import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';

interface Props {
    isLoading?: boolean;
    children?: ReactNode;
    size?: number;
    className?: string;
    noBlock?: boolean;
}

const Loader = ({ isLoading = true, children, size, noBlock, className }: Props) => {
    return (
        <AnimatePresence>
            {isLoading ? (
                <motion.div
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-py-12"
                >
                    <Spinner color="success" />
                </motion.div>
            ) : (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.15 }}
                    className={cx(!noBlock && 'tw-h-full tw-w-full', className)}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Loader;
